<template>
  <div>
    <!-- 增值服务 {{id}} {{type}} -->
    <div class="content-header">
      <div class="left">
        <span class="title">授权管理</span>
      </div>
      <div class="right"></div>
    </div>

    <div class="pageTitle">选择产品类型</div>
    <div class="itembox">
      <div class="item" @click="toPages('my_code')">
        <div class="iconfont_box">
          <span class="iconfont">&#xe672;</span>
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">智能运维</p>
          </div>
          <div class="des">管理“智能运维”产品的运营期安全码</div>
        </div>
      </div>
      <div class="item" @click="toPages('active-code')">
        <div class="iconfont_box">
          <span class="iconfont">&#xe671;</span>
        </div>
        <div class="r_box">
          <div class="titbox">
            <p class="tit">私有服务器</p>
          </div>
          <div class="des">
            管理“私有服务器”产品在设备端和文件服务器端的激活码
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {
    toPages (name) {
      if (name !== 'active-code') {
        this.$router.push({
          name
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
